export const COM_CONTACTUS_FORM_REQUEST = 'COM_CONTACTUS_FORM_REQUEST';
export const COM_CONTACTUS_FORM_SUCCESS = 'COM_CONTACTUS_FORM_SUCCESS';
export const COM_CONTACTUS_FORM_ERROR   = 'COM_CONTACTUS_FORM_ERROR';

export const EVENT_CONTACT_US_SUCCESS = 'EVENT_CONTACT_US_SUCCESS';
export const EVENT_CONTACT_US_ERROR   = 'EVENT_CONTACT_US_ERROR';